__turbopack_context__.v({
  "control": "index-module__RXmykG__control",
  "indicator": "index-module__RXmykG__indicator",
  "label": "index-module__RXmykG__label",
  "root": "index-module__RXmykG__root",
  "sections": "index-module__RXmykG__sections",
});
